import React, { useEffect, useRef } from 'react';
import { FuelIcon } from '@frete.com/fuel-react';
import BaseModal from '../BaseModal';
import { BaseModalProps } from '../BaseModal/BaseModalTypes';
import * as Styled from './ModalStyles';
import { TModalWidth } from './ModalTypes';

interface ModalProps extends BaseModalProps {
  width?: TModalWidth;
  fixedMaxWidth?: boolean;
  showCloseButton?: boolean;
  hOverlay?: boolean;
  isChildModal?: boolean;
  portalName?: string;
  noMarginContent?: boolean;
}
function Modal({
  children,
  width,
  fixedMaxWidth,
  showCloseButton,
  hOverlay,
  isChildModal,
  portalName,
  noMarginContent,
  onClose,
  ...rest
}: ModalProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const baseRef = useRef<HTMLDivElement>(null);

  const handleClose = (where: 'btnClose' | 'overlay') => {
    if (contentRef.current && baseRef.current) {
      contentRef.current.classList.remove('animated');
      baseRef.current.classList.remove('animated');
      setTimeout(() => {
        onClose?.(where);
      }, 200);
    }
  };

  useEffect(() => {
    if (rest.isOpen) {
      baseRef.current?.classList.add('animated');
      contentRef.current?.classList.add('animated');
    }
  }, [rest.isOpen, baseRef.current, contentRef.current]);

  return (
    <BaseModal
      hOverlay={hOverlay}
      isChildModal={isChildModal}
      onClose={() => handleClose('overlay')}
      {...rest}
      innerRef={baseRef}
      modalName={portalName}
    >
      <Styled.Stage
        width={width || 'xs'}
        fixedMaxWidth={fixedMaxWidth}
        ref={contentRef}
      >
        <Styled.PaperCustom spacing={6} noMargin={noMarginContent}>
          {showCloseButton && (
            <Styled.CloseButton
              onClick={() => handleClose('btnClose')}
              data-testid="btn-close-modal"
            >
              <FuelIcon size="tiny" name="close" />
            </Styled.CloseButton>
          )}
          {children}
        </Styled.PaperCustom>
      </Styled.Stage>
    </BaseModal>
  );
}

export default Modal;
